import React, { useState } from "react";
import GlobalVariable from "../../../services/globalVar.js";
import { classNames } from 'primereact/utils'; 

const BalanceSheet = (props) => {
  const parentDatas = props;
  const currency = GlobalVariable.userDet.tenantConfig.currency;
  const [expandedAssets, setExpandedAssets] = useState({});
  const [expandedLiabilities, setExpandedLiabilities] = useState({});

  const toggleAssetCategory = (index) => {
    setExpandedAssets((prevState) => ({
      ...prevState,
      [index]: !prevState[index], 
    }));
  };

  const toggleLiabilityCategory = (index) => {
    setExpandedLiabilities((prevState) => ({
      ...prevState,
      [index]: !prevState[index], 
    }));
  };


  return (
    <div
    style={{
      display: "flex",
      justifyContent: "space-between",
    }}
  >
    <div className="card card-borderless py-2" style={{ width: "50%", padding: "0 10px" }}>
      <h2 style={{ textAlign: "center" }}>Assets</h2>
      <div className="d-flex justify-content-between p-2" style={{ backgroundColor: "#EAF2E3" }}>
        <strong className="m-0 d-inline-flex">Particular</strong>
        <strong className="m-0 d-inline-flex">Amount ({currency})</strong>
      </div>
      <table className="mb-4" style={{ width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "transparent" }}>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(parentDatas.balanceSheetAssets?.coaCategoryList) &&
            parentDatas.balanceSheetAssets.coaCategoryList.map((type, i) => (
              <React.Fragment key={i}>
                {/* Category Row */}
                <tr
                  style={{ border: "1px solid rgb(224 224 224)", cursor:"pointer", fontWeight: "bold" }}
                  onClick={() => toggleAssetCategory(i)}
                >
                  <td style={{ border: "none" }}>
                    <span className="d-flex align-items-center fw-bold">
                      {type.coaCategoryName}
                      {Array.isArray(type.masCOAList) && (
                        <i
                          className={classNames('pi',
                            expandedAssets[i] ? 'pi-angle-down' : 'pi-angle-right',
                            'ms-2')}
                        ></i>
                      )}
                    </span>
                  </td>
                  <td
                    className="text-end fw-bold"
                    style={{
                      color: type?.total < 0 ? "red" : "inherit", border:"none"
                    }}
                  >
                    {type?.total?.toFixed(2)}
                  </td>
                </tr>

                {expandedAssets[i] &&
                  Array.isArray(type.masCOAList) &&
                  type.masCOAList.map((item, k) => (
                    <tr key={k} style={{ border: "1px solid rgb(224 224 224)" }}>
                      <td className="ps-3">{item.coaName}</td>
                      <td
                        className="text-end"
                        style={{
                          color: item.amount < 0 ? "red" : "inherit",
                          border: "none",
                        }}
                      >
                        {item?.amount?.toFixed(2)}
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>

    <div className="card card-borderless py-2" style={{ width: "49%", padding: "0 10px" }}>
      <h2 style={{ textAlign: "center" }}>Liability</h2>
      <div className="d-flex justify-content-between p-2" style={{ backgroundColor: "#EAF2E3" }}>
        <strong className="m-0 d-inline-flex">Particular</strong>
        <strong className="m-0 d-inline-flex">Amount ({currency})</strong>
      </div>
      <table className="mb-4" style={{ width: "100%" }}>
        <thead>
          <tr style={{ backgroundColor: "transparent" }}>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(parentDatas.balanceSheetLiability?.coaCategoryList) &&
            parentDatas.balanceSheetLiability.coaCategoryList.map((type, j) => (
              <React.Fragment key={j}>
                <tr
                  style={{ border: "1px solid rgb(224 224 224)",cursor:"pointer", fontWeight: "bold" }}
                  onClick={() => toggleLiabilityCategory(j)}
                >
                  <td style={{ border: "none" }}>
                    <span className="d-flex align-items-center fw-bold">
                      {type.coaCategoryName}
                      {Array.isArray(type.masCOAList) && (
                        <i
                          className={classNames(
                            'pi',
                            expandedLiabilities[j] ? 'pi-angle-down' : 'pi-angle-right',
                            'ms-2'
                          )}
                        ></i>
                      )}
                    </span>
                  </td>
                  <td
                    className="text-end fw-bold"
                    style={{
                      color: type?.total < 0 ? "red" : "inherit", border:"none"
                    }}
                  >
                    {type?.total?.toFixed(2)}
                  </td>
                </tr>

                {expandedLiabilities[j] &&
                  Array.isArray(type.masCOAList) &&
                  type.masCOAList.map((item, k) => (
                    <tr key={k} style={{ border: "1px solid rgb(224 224 224)" }}>
                      <td className="ps-3">{item.coaName}</td>
                      <td
                        className="text-end"
                        style={{
                          color: item.amount < 0 ? "red" : "inherit",
                          border: "none",
                        }}
                      >
                        {item?.amount?.toFixed(2)}
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>
  </div>
  );
};

export default BalanceSheet;
